import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Item } from "src/app/frontoffice/catalog/model/item.model";
import { PortalService } from "../../portal.service";

@Component({
  selector: "ngx-item-image-uploader",
  templateUrl: "./item-image-uploader.component.html",
  styleUrls: ["./item-image-uploader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemImageUploaderComponent extends BaseFormComponent<any> {
  private formData: FormData = new FormData();
  @Input() item: Item;
  @ViewChild("mainImageElement") mainImageElement: ElementRef;
  slideImages: any[] = [];
  imagePaths: any;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private ps: PortalService) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.httpCommonService.get("Peripheral/ItemImage/" + this.item?.Id).subscribe((response: any) => {
      this.imagePaths = response[0];
      response.slice(1).forEach((element) => this.slideImages.push({ src: element, name: element.split("/").pop() }));
      this.cd.markForCheck();
    });
  }

  onSubmit(): void {
    this.formData.append("ItemId", this.item?.Id.toString());
    this.httpCommonService.upload("Peripheral/ItemImage", this.formData).subscribe((response) => {
      if (response) {
        this.sts.showToast("success", "", this.translate("ClientApp.FrontOffice.Portal.ItemImage.ImagesUploadedSuccessfully"), 3000);
        this.ps.itemImages[this.item.Id] = response[0] + "?" + Math.random().toString();
        this.close();
      }
    });
  }

  onMainImageChange(event) {
    const file = event.target.files[0];
    if (file) {
      const maxSize = 300000;
      const maxHeight = 512;
      const maxWidth = 512;
      if (file.size > maxSize) {
        let error =
          this.translate("ClientApp.FrontOffice.Portal.ItemImage.UploadedImageSizeMustLessThan") +
          maxSize / 1000 +
          this.translate("ClientApp.FrontOffice.Portal.ItemImage.BeKb");
        this.sts.showDialog(error, this.translate("ClientApp.FrontOffice.Portal.ItemImage.Error"));
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let image = new Image();
        image.src = e.target.result;
        image.onload = (rs: any): any => {
          const imgHeight = rs.currentTarget["height"];
          const imgWidth = rs.currentTarget["width"];
          if (imgHeight > maxHeight || imgWidth > maxWidth) {
            let error = this.translate("ClientApp.FrontOffice.Portal.ItemImage.ImageSizeNotAllowed");
            this.sts.showDialog(error, this.translate("ClientApp.FrontOffice.Portal.ItemImage.Error"));
            return false;
          } else {
            if (this.formData.get("MainImage")) this.formData.delete("MainImage");
            this.mainImageElement.nativeElement.src = image.src as string;
            this.formData.append("MainImage", file);
          }
        };
      };
      reader.readAsDataURL(file);
    }
  }

  onSlideImageChange(event) {
    if (event.target.files && event.target.files.length) {
      const max_size = 300000;
      const max_height = 2212;
      const max_width = 2212;

      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];

        if (file.size > max_size) {
          let error =
            this.translate("ClientApp.FrontOffice.Portal.ItemImage.UploadedImageSizeMustLessThan") +
            max_size / 1000 +
            this.translate("ClientApp.FrontOffice.Portal.ItemImage.BeKb");
          this.sts.showDialog(error, this.translate("ClientApp.FrontOffice.Portal.ItemImage.Error"));
          return false;
        }

        this.checkImageSize(file, max_height, max_width, "SlideImages");
      }
    }
  }

  checkImageSize(file, max_height, max_width, filedName) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      let image = new Image();
      image.src = e.target.result;

      image.onload = (rs: any): any => {
        const img_height = rs.currentTarget["height"];
        const img_width = rs.currentTarget["width"];

        if (img_height > max_height || img_width > max_width) {
          let error = this.translate("ClientApp.FrontOffice.Portal.ItemImage.ImageSizeNotAllowed");
          this.sts.showDialog(error, this.translate("ClientApp.FrontOffice.Portal.ItemImage.Error"));
          return false;
        } else {
          this.addSlide(image.src, file.name);
          this.formData.append(filedName, file);
        }
      };
    };

    reader.readAsDataURL(file);
  }

  addSlide(src, name) {
    this.slideImages.push({ src: src as string, name: name });
    this.cd.markForCheck();
  }

  removeSlide(image) {
    const fieldName = "SlideImages";
    const indexInSlideImages = this.slideImages.findIndex((f) => f.name === image.name);
    const formDataImages = this.formData.getAll(fieldName);
    if (indexInSlideImages !== -1) {
      this.slideImages.splice(indexInSlideImages, 1);
      if (image.src.includes("http")) {
        this.httpCommonService.deleteByParameter("Peripheral/ItemImage/" + this.item.Id + "?fileName=" + image.name).subscribe((res) => {
          if (res) this.sts.showToast("danger", "", this.translate("ClientApp.FrontOffice.Portal.ItemImage.ImageRemoved"), 3000);
        });
      } else {
        const images = formDataImages.filter((f: any) => f.name !== image.name);
        this.formData.delete(fieldName);
        images.map((m) => this.formData.append(fieldName, m));
      }
    }
  }
}
